export enum ViewLabels {
  NMSNQCQS = 'NMS (NQ/CQS)',
  Scorecard = 'All',
  OTCForeign = 'OTC-Foreign',
  Spread = 'Customer to Customer'
}